import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';

const TaskFormContainer = styled.div`
    margin: 50px 0;
`

const TaskInput = styled.input`
    font-size: 24px;
    border: none;
    background: none;
    border-bottom: 5px solid #0984e3;
    box-shadow: none;
    padding: 10px 20px;
    color: #0984e3;

    ::placeholder {
        color: #0984e3;
    }

    :active,
    :focus {
        outline: 0;
    }
`

const FormSubmit = styled.input`
    font-size: 18px;
    background-color: #0984e3;
    border: none;
    border-radius: 5px;
    border-bottom-left-radius: 0;
    padding: 16px 20px;
    color: #fff;
    font-weight: bold;

    :hover {
        cursor: pointer;
    }
`

class TaskForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            color: '#2d3436',
            isActive: false
        };

        this.form = React.createRef();

        this.handleTaskInputChange = this.handleTaskInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleTaskInputChange(e) {
        this.setState({title: e.target.value});
    }

    handleSubmit(e) {
        e.preventDefault();
        // Create the task.
        this.props.create(this.state);
        // Reset the form.
        this.setState({
            title: ''
        });
    }

    render() {
        return (
            <TaskFormContainer>
                <form onSubmit={this.handleSubmit}>
                    <TaskInput value={this.state.title} placeholder="New Task" onChange={this.handleTaskInputChange}/>
                    <FormSubmit type="submit" value="Create"/>
                </form>
            </TaskFormContainer>
        )
    }
}

TaskForm.propTypes = {
    create: propTypes.func.isRequired
}

export default TaskForm;


// WEBPACK FOOTER //
// ./src/components/TaskForm.js